// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * fps-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: local
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PhoneVerificationStatusAPIModel,
    PhoneVerificationStatusAPIModelFromJSON,
    PhoneVerificationStatusAPIModelFromJSONTyped,
    PhoneVerificationStatusAPIModelToJSON,
} from './';

/**
 * 
 * @export
 * @interface PhoneDataAPIModel
 */
export interface PhoneDataAPIModel {
    /**
     * 
     * @type {string}
     * @memberof PhoneDataAPIModel
     */
    number: string;
    /**
     * 
     * @type {PhoneVerificationStatusAPIModel}
     * @memberof PhoneDataAPIModel
     */
    status: PhoneVerificationStatusAPIModel;
}

export function PhoneDataAPIModelFromJSON(json: any): PhoneDataAPIModel {
    return PhoneDataAPIModelFromJSONTyped(json, false);
}

export function PhoneDataAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhoneDataAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'number': json['number'],
        'status': PhoneVerificationStatusAPIModelFromJSON(json['status']),
    };
}

export function PhoneDataAPIModelToJSON(value?: PhoneDataAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'number': value.number,
        'status': PhoneVerificationStatusAPIModelToJSON(value.status),
    };
}


